import { useResidentContext } from "app/features/residents/provider/ResidentProvider";
import { FormEnums } from "app/services/api/types/forms/enums/FormEnums";
import { AssessmentReportFillTemplate } from "../../../features/reporting/templates/AssessmentReportFillTemplate";

export function CarePlanSubmitScreen() {
  const { resident } = useResidentContext();

  const backPath = resident?.id
    ? `/residents/${resident.id}/care-plans`
    : undefined;

  return (
    <AssessmentReportFillTemplate
      tag={FormEnums.CARE_ASSESSMENT}
      backPath={backPath}
    />
  );
}
